<template>
  <facebook-login class="mb-3 w-full"
    appId="435564053656119"
    @login="onFacebookLogin"
    @logout="onFacebookLogout"
    @sdk-init="onSdkInit"
    :fields="'name,email,picture'"
    :version="'v16.0'">
    <button>Facebook 登入</button>
  </facebook-login>
</template>

<script>
import FacebookLogin from 'vue-facebook-login-component'
export default {
  components: {
    FacebookLogin
  },
  data () {
    return {
      fbUser: null
    }
  },
  methods: {
    onFacebookLogin (response) {
      console.log('登入成功:', response)
      this.fbUser = response
      const accessToken = response.authResponse.accessToken

      console.log(accessToken)

      this.$store.dispatch('loginFB', accessToken)
    },
    onFacebookLogout () {
      console.log('使用者已登出')
      this.fbUser = null
    },
    onSdkInit () {
      console.log('Facebook SDK 初始化完成')
    }
  }
}
</script>
